module.exports = __webpack_public_path__ + "static/media/nit_trichy_logo.2ceefbac.png";